module.exports = __webpack_public_path__ + "img/share.181e3f5a.png";